import styled from 'styled-components';
import { Header4 } from '@glowforge/gf-styled/components/typography/Typography';
import Markdown from '@glowforge/gf-styled/components/markdown';
import { Button } from '@glowforge/gf-styled/components';

export const UnderlineHeading = styled(Header4)`
  padding: 0 2px 1px 2px;
  position: relative;
  margin-right: 4px;

  &:before {
    content: '';
    width: 100%;
    border-bottom: 4px solid ${(props) => props.theme.colors.magic.base};
    position: absolute;
    bottom: 4px;
    z-index: -1;
  }
`;

export const ReferralHeader = styled('p')`
  display: block;
  margin-top: 32px;
  line-height: 1.2;

  @media ${(props) => props.theme.queries.tabletAndUp} {
    margin-top: 0;
  }
`;

export const CloseButton = styled(Button)`
  border: none;
  box-shadow: none;

  &:hover {
    box-shadow: none;
    text-decoration: underline;
  }
`;

export const HeaderWrapper = styled('div')`
  grid-column: main-start / main-end;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: fit-content;
  margin-bottom: 8px;
  flex-direction: column-reverse;
  width: 100%;

  @media ${(props) => props.theme.queries.tabletAndUp} {
    flex-direction: row;
  }
`;

export const ReferralPortrait = styled('img')`
  border-radius: 50%;
  height: 65px;
  width: 65px;
  margin-right: 8px;
`;

export const SubHeaderWrapper = styled('div')`
  grid-column: main-start / main-end;
  display: flex;
  align-items: center;
  margin: 8px 0;
`;

export const BodyWrapper = styled(Markdown)`
  grid-column: main-start / main-end;
  margin: 8px 0;
`;

export const ApplyButton = styled(Button)`
  // allow text to wrap so will not overflow container
  white-space: normal;
`

export const ButtonWrapper = styled('div')`
  grid-column: main-start / main-end;

  .button-icon-wrapper {
    svg {
      fill: white;
      stroke: white;
    }
  }
`;
